import { lazy } from 'react';

const AgentAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/agent',
      component: lazy(() => import('./AgentApp')),
    },
    
  ],
};

export default AgentAppConfig;
